// removed by extract-text-webpack-plugin
module.exports = {"policy":"_2_tk3j9P6TOu2dAx_6EJgg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/PolicyMobile/PolicyMobile.scss
// module id = 1150
// module chunks = 0